import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Loader_Operation_Search_Fields: {[id: string]: ISearchProviderField} = {
    WB_LOADEROPERATION_ID:                  {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Loader Operation Id',                   columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {}},
    LOADEROPERATION_ID:                     {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Loader Operation Id',                      columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    LOADEROPERATION_NAME:                   {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Loader Operation Name',                    columnResourceName: 'colLOperName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    REQUIRED_DIMENSIONS:                    {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Required Dimensions',                      columnResourceName: 'colReqDim',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    OPERATION_TYPE:                         {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Operation Type',                           columnResourceName: 'colOperType',       alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    DIMENSION_ID:                           {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Dimension Id',                             columnResourceName: 'colDimId',          alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CLASS_ID:                               {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Class Id',                                 columnResourceName: 'colClassId',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SOURCE_TABLE:                           {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Source Table',                             columnResourceName: 'colSrcTbl',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SOURCE_FILTER:                          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Source Filter',                            columnResourceName: 'colSrcFltr',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SOURCE_FIELDNAME:                       {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Source Field Name',                        columnResourceName: 'colSrcFldName',     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TARGET_FIELDNAME:                       {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Target Field Name',                        columnResourceName: 'colTrgtFldName',    alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TARGET_ALLOCATION_BASIS_FIELDNAME:      {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Target Allocation Basis FieldName',        columnResourceName: 'colTrgtAlloc',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SOURCE_FIELDNAME2:                      {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Source Field Name 2',                      columnResourceName: 'colSrcFldName2',    alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    DATE_RELEVANT_IND:                      {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Date Relevant Ind',                        columnResourceName: 'colDateRel',        alignment: HorizAlignment.Left},  domainOptions: {}},
    STARTDT_FIELDNAME:                      {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Start Date Field Name',                    columnResourceName: 'colStrtDtFldName',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    ENDDT_FIELDNAME:                        {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'End Date Field Name',                      columnResourceName: 'colEndDtFldName',   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MDSET_NAME:                             {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Master Data Set Name',           columnResourceName: 'colLName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COMPANY_NAME:                           {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Company Name',           columnResourceName: 'colLName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },

};

const LoaderOperationSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_LOADEROPERATION_ID',
                id_ui: 'LOADEROPERATION_ID',
                name: 'LOADEROPERATION_NAME'
    },

    searchProviderFields: vUI_Loader_Operation_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Loader_Operation_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const LoaderOperationSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "LoaderOperationSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'LOADEROPERATION_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'LOADEROPERATION_NAME', renderOptions: {}}
    ], // ISearchFields
    profileDisplayFields: [
         'LOADEROPERATION_ID', 'LOADEROPERATION_NAME', 'OPERATION_TYPE','DIMENSION_ID','SOURCE_TABLE', 'MDSET_NAME', 'COMPANY_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: LoaderOperationSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const LoaderOperationSearch: ISearch = {
    searchName: "Find Loader Operation",
    renderOptions: {ui5ResourceId: "LoaderOperationSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [LoaderOperationSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("LoaderOperationBO", "LoaderOperation", LoaderOperationSearch, "Loader Operation Search")
export {LoaderOperationSearch}
